import { getPlatform } from './platforms';
// Create a proxy that implements the plugin interface using platform abstraction
const QRCodeStudio = new Proxy({}, {
    get(_target, prop) {
        return async (...args) => {
            const platform = await getPlatform();
            const method = platform[prop];
            if (typeof method === 'function') {
                return method.apply(platform, args);
            }
            throw new Error(`Method ${prop} not found on platform adapter`);
        };
    }
});
// Export platform utilities for advanced users
export { getPlatform, platformDetector } from './platforms';
export * from './definitions';
export * from './components';
export * from './hooks';
export { QRCodeStudio };
// Export validators for advanced users
export { validateQRData, QRValidationError } from './core/validators/qr-validators';
// Export utility validators
export { isValidUrl, isValidEmail, isValidPhoneNumber, isValidHexColor, isValidQRSize } from './utils/validators';
// Export form utilities
export { qrFormFields, qrTypeInfo } from './utils/qr-forms';
// Export logger for advanced users
export { logger } from './utils/logger';
//# sourceMappingURL=index.js.map